
import { Component, Vue,Emit } from 'vue-property-decorator'
import { UpdateOrderRecordStateInput,OrderRecordBySchoolDto} from '@/api/service-proxies'
import { __param } from "tslib";
import { orderRecordService } from '@/api/payments/order-record';

@Component
export default class DealDialog extends Vue {
  private dialogVisible: boolean = false
  phoneNumber = ""
  isSkipHolidays:boolean = false
  isExporting:boolean=false
  orderRecordBySchoolDto = new OrderRecordBySchoolDto()
  input = new UpdateOrderRecordStateInput()
  public open(row,tenantId ) {
    this.input.tenantId = Number(tenantId);
    this.input.id = row.id;
    this.orderRecordBySchoolDto = row;
    this.dialogVisible = true
  }
  close(){
    this.dialogVisible = false;
  }
  errorHandler() {
    return true
  }
  submit(){
    this.input.phoneNumber = this.phoneNumber;
    orderRecordService.updateOrderRecordDeal(this.input)
    .then(()=>{
      this.$message.success('确认办理成功');
      this.onSuccess()
    })
    .catch(()=>{
      this.$message.success('确认办理失败');
    })
    .finally(()=>{
      this.dialogVisible = false
    })
  }
  @Emit("success")
    private onSuccess() {}
 
}

